import { useState } from 'react';
import { clearActiveStack, getActiveStack, isPreviewBuild } from 'src/config/backend';
import { SplashScreen } from 'src/modules/splash-screen';
import { clearRevertNotice, getRevertNotice } from 'src/modules/previewStackHealth';

const PreviewBadge = () => {
  const [dismissed, setDismissed] = useState(false);
  if (!isPreviewBuild()) return null;
  const active = getActiveStack();
  const notice = dismissed ? null : getRevertNotice();
  if (!active && !notice) return null;

  const softReset = () => {
    clearActiveStack();
    void SplashScreen.reloadPageWithCover('preview');
  };
  const dismiss = () => {
    clearRevertNotice();
    setDismissed(true);
  };

  return (
    <div
      data-testid="preview-badge"
      className="fixed bottom-2 right-[calc(var(--app-column-left,0px)+0.5rem)] z-popover flex items-center gap-2 bg-warning-neutral text-white text-xs px-2 py-1 rounded"
    >
      {active ? (
        <>
          <span>PREVIEW: {active.slug}</span>
          <button
            data-testid="preview-badge-reset"
            className="bg-transparent underline"
            onClick={softReset}
          >
            Reset
          </button>
        </>
      ) : (
        <>
          <span>Preview &ldquo;{notice}&rdquo; unreachable — on staging</span>
          <button
            data-testid="preview-badge-dismiss"
            className="bg-transparent underline"
            onClick={dismiss}
          >
            Dismiss
          </button>
        </>
      )}
    </div>
  );
};

export default PreviewBadge;
